/*
   Chaque item contient l'ensemble des données des cartes institution de la sidebar (aussi appelé établissements dans le code)
   Trie par la clé "type_slug" :
   1. mon-appart/ma-villa,
   2. mon-terrain
   3. Et puis le reste sur "Mon Delta Habitat"
   Note : Ne peut se positionner chez un composant enfant du client car se doit d'être mis ici sur les composants "globaux" pour fonctionner.
*/
export const sortEtablissements = (data, orderItems, key) => {
    return [...data].sort((a, b) => {
        const priorityA = getPriority(a[key], orderItems);
        const priorityB = getPriority(b[key], orderItems);

        if (priorityA !== priorityB) {
            return priorityA - priorityB;
        }
        return 0;
    });
};

const getPriority = (typeSlug, order) => {
    for (let i = 0; i < order.length; i++) {
        if (order[i].some(item => typeSlug.includes(item))) {
            return i;
        }
    }
    return 2;
};

/*
const getPriority = (typeSlug) => {
    if (typeSlug.includes("mon-appart") || typeSlug.includes("ma-villa")) return 0;
    if (typeSlug.includes("mon-terrain")) return 1;
    return 2;
};
*/
